import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { LicenseType } from '@models/license';
import { IlClassStatusEnum } from '@queries/generated';
import { ILClassService } from '@services/instructor-led/il-class.service';
import { Fade } from '@util/animations';
import { BehaviorSubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'vnm-il-booking-table-row',
  templateUrl: './il-booking-table-row.component.html',
  styleUrls: ['./il-booking-table-row.component.scss'],
  animations: [Fade]
})
export class IlBookingTableRowComponent implements OnInit {
  @ViewChild('itemTemplate', { static: true }) itemTemplate;

  @Input() license: LicenseType;

  ilCourseIds$ = new BehaviorSubject<string[]>([]);
  ilClasses$ = this.ilCourseIds$.pipe(
    /// Find the classes for the given ilCourseIds
    switchMap((ilCourseIds) =>
      this.ilClassService.list({
        ilCourseIds,
        forTrainingManager: true,
        status: [IlClassStatusEnum.Active, IlClassStatusEnum.Running]
      })
    ),
    /// Creates a copy of the original because it's a read-only.
    map((classes) => [...classes]),
    /// Sort by ilCourse.name and startsAt
    map((classes) =>
      classes.sort((a, b) => {
        const nameComparison = a.ilCourse.name.localeCompare(b.ilCourse.name);
        if (nameComparison !== 0) {
          return nameComparison;
        }
        return new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime();
      })
    )
  );

  constructor(private ilClassService: ILClassService, private viewContainerRef: ViewContainerRef) {}

  ngOnInit() {
    if (this.license) {
      const { courseItems } = this.license.course;
      const hasILCourse = courseItems?.some((item) => item.ilCourse !== null);

      if (hasILCourse) {
        const ilCourseItems = courseItems.filter((item) => item.ilCourse?.id);
        const ilCourseIds = ilCourseItems.map((item) => item.ilCourse.gid);

        this.ilCourseIds$.next(ilCourseIds);

        // hoist our template into the parent table so it renders nice
        this.viewContainerRef.createEmbeddedView(this.itemTemplate);
      }
    }
  }
}
